import React, { useState, useEffect, useRef } from "react";
import { useRecoilState } from "recoil";
import {
  userState,
  agreePrivacyPolicyState,
  agreeMarkekingState,
} from "../../stores/atoms";

function Agreement({ isLogined, history }) {
  const [, setUser] = useRecoilState(userState);
  const [isAgreeCheck, setIsAgreeCheck] = useState(false);
  const [isAgree1, setIsAgree1] = useState(false);
  const [isAgree2, setIsAgree2] = useState(false);
  const [isAgree3, setIsAgree3] = useState(false);
  const [isAgree4, setIsAgree4] = useState(false);
  const [isAgreePrivacyPolicy, setIsAgreePrivacyPolicy] = useRecoilState(
    agreePrivacyPolicyState
  );
  const [isAgreeMarketing, setIsAgreeMarketing] = useRecoilState(
    agreeMarkekingState
  );
  const [isAllAgree, setIsAllAgree] = useState(false);
  const submitButtonRef = useRef();
  const checkboxRef = useRef();

  useEffect(() => {
    document.documentElement.scrollTop = 0;
  }, []);

  useEffect(() => {
    if (!isAgree1 || !isAgree2) {
      setIsAgreeCheck(false);
      setIsAllAgree(false);
    } else {
      setIsAgreeCheck(true);
    }

    if (isAgree3) {
      setIsAgreePrivacyPolicy(true);
    } else {
      setIsAllAgree(false);
      setIsAgreePrivacyPolicy(false);
    }
    if (isAgree4) {
      setIsAgreeMarketing(true);
    } else {
      setIsAllAgree(false);
      setIsAgreeMarketing(false);
    }

    if (isAgree1 && isAgree2 && isAgree3 && isAgree4) {
      setIsAllAgree(true);
      setIsAgreePrivacyPolicy(true);
      setIsAgreeMarketing(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    isAgree1,
    isAgree2,
    isAgree3,
    isAgree4,
    isAgreePrivacyPolicy,
    isAgreeMarketing,
  ]);

  if (isLogined) {
    setUser(null);
    sessionStorage.removeItem("user");
  }

  const allAgreeCheck = () => {
    if (isAllAgree) {
      setIsAllAgree(false);
      setIsAgreeCheck(false);
      setIsAgree1(false);
      setIsAgree2(false);
      setIsAgree3(false);
      setIsAgree4(false);
    } else {
      setIsAllAgree(true);
      setIsAgreeCheck(true);
      setIsAgree1(true);
      setIsAgree2(true);
      setIsAgree3(true);
      setIsAgree4(true);
    }
  };

  const onFormSubmit = (event) => {
    event.preventDefault();
    if (isAgreeCheck) {
      history.push("/register");
    } else {
      alert("약관동의 필수시항에 체크해주세요");
    }
  };

  return (
    <>
      <div className="agreement">
        <h3>약관동의</h3>
        <p className="txt-center font-small txt-gray">
          기업 관리자께서 가입해주세요!
          <br />
          고요한 비즈니스의 원활한 사용을 위해
          <br />
          서비스 약관, 개인정보 수집 및 이용에 동의해주세요.
        </p>
        <form className="item" onSubmit={onFormSubmit}>
          <div ref={checkboxRef}>
            <div className="item-header">
              <h6 className="font-bold txt-black">제1조 (목적)</h6>
              <p>
                본 약관은 코액터스(주)(이하 “회사”라 한다)가 제공하는 “고요한
                비즈니스 서비스”의 이용과 관련하여 회사와 회원과의 권리, 의무 및
                책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.
              </p>
              <h6 className="font-bold txt-black">제2조 (정의)</h6>
              <p>① 본 약관에서 사용하는 용어의 정의는 다음과 같습니다.</p>
              <p>
                1) “고요한 비즈니스 서비스” 또는 “서비스”라 함은 회사가 “고요한
                비즈니스 웹”, “고요한 모빌리티(이하 “고요한M”이라 합니다.)” 앱
                및 웹, 기타수단 등 (이하 통칭하여 “고요한M 앱 등” 이라 한다)을
                통해서 “회원”의 임직원 또는 “회원”의 임직원이 지정한 자(이하
                “임직원 등”이라 한다)와 “고요한M” 플랫폼 차량을 연결하고,
                “회원”의 이용요금 및 정산 등을 위해 제공하는 서비스 일체를
                말합니다.
              </p>
              <p>
                2) “회원”이라 함은 회사가 제공하는 “서비스”를 이용하기 위하여 본
                약관에 동의하고 회사의 회원으로 가입하는 자를 말합니다.
              </p>
              <p>
                3) “매칭”이라 함은 회원이 “고요한M 앱 등” 플랫폼에서 출발지와
                목적지를 입력하고, 쿠폰 등을 포함하는 결제 수단을 선택한 후
                “호출하기” 또는 “예약"버튼을 통해 서비스 이용을 요청(이하 “이용
                요청”이라고 합니다)하면, 요청 시점에 회사 소속의 드라이버가
                “고요한M” 플랫폼을 통하여 수락함으로써, 회원과 회사 간의 계약이
                체결된 상태를 의미합니다.
              </p>
              <p>
                4) “플랫폼”이라 함은 회사가 회원에게 “서비스”를 제공하기 위하여
                개발한 “고요한M” 어플리케이션을 의미합니다.
              </p>
              <p>
                5) “자동 결제”라 함은 회원이 회사의 회원으로 가입할 당시 입력한
                신용카드 등의 결제정보에 기반하여 서비스 이용이 종료될 때 또는
                서비스 이용 예약이 확정될 때마다 별도의 인증과정이 없이
                이용요금이 자동으로 결제되는 것을 의미합니다.
              </p>
              <p>
                6) “이용요금”이라 함은 (i) 회원이 회사의 운송수단을 예약하거나
                호출하여 이동하는 운송서비스를 이용하는 비용, (ii) 회사에
                지급하는 서비스 중개수수료 및 기타 비용 등을 총칭하여
                의미합니다.
              </p>
              <p>
                7) “관리책임자”와 “운영담당자”라 함은 “회원”이 “서비스”를
                이용하기 위해 지정한 임직원을 말하고, 다음 각 목과 같이
                구분합니다.
              </p>
              <p>
                가. 관리책임자 : “회원”의 “서비스” 이용을 총괄하는 임직원으로서
                “고요한 비즈니스 웹”에서 “회원”의 계정을 직접 생성하거나
                “관리책임자” 자격을 이전 받은 자
              </p>
              <p>
                나. 운영담당자 : “회원”의 임직원으로서 “관리책임자”의 “서비스”
                이용 총괄 업무를 대행 또는 지원하기 위해 “관리책임자”가 “고요한
                비즈니스 웹”에서 초대한 자
              </p>
              <p>
                8) “고요한 비즈니스 웹”이라 함은 “회원”이 “서비스”를 이용함에
                있어서 임직원 지정, 결제 수단 관리, 결제카드 관리, 정산 정보
                열람 등을 할 수 있도록 “회사”가 제공하는 웹 사이트를 말합니다.
              </p>
              <p>
                9) “계정”이라 함은 “고요한 비즈니스 웹” 이용 “회원”의 식별을
                위해 “회사”가 부여한 식별값과 “관리책임자”, “운영담당자”의
                “고요한 비즈니스 웹”의 접속을 위해 “관리책임자” 및
                “운영담당자”가 지정한 ID와 PW를 말합니다.
              </p>
              <p>
                ② 본 약관에 사용되는 용어 중 본 조에서 정하지 아니한 부분은 본
                약관의 다른 조항, 관계법령 및 일반(상)관례에 따릅니다.
              </p>
              <h6 className="font-bold txt-black">
                제3조 (약관의 효력 및 변경)
              </h6>
              <p>
                ① 본 약관은 “서비스”를 이용하고자 하는 모든 회원에 대하여 그
                효력을 발생합니다.
              </p>
              <p>
                ② 회사는 본 약관의 내용을 회원이 쉽게 알 수 있도록 플랫폼 화면에
                게시하거나 회사 홈페이지의 팝업 등 기타 적절한 방법으로 회원에게
                공지합니다.
              </p>
              <p>
                ③ 회사는 「약관의 규제에 관한 법률」, 「정보통신망 이용촉진 및
                정보보호 등에 관한 법률」(이하 “정보통신망법”) 등 관련법령을
                위배하지 않는 범위에서 본 약관을 개정할 수 있습니다. 만약 회원의
                명시적인 동의절차를 거치지 않고 약관을 개정할 경우 회사는 지체
                없이 개정약관을 현행약관과 함께 이메일 또는 제2항과 같은
                방법으로 개정약관의 적용일자 7일 전에 공지 또는 통지합니다.
                다만, 회원의 권리 또는 의무와 관련하여 중요한 약관내용의 변경은
                개정된 약관을 적용하고자 하는 날 30일 이전에 공지 또는
                통지합니다. 단, 회원의 연락처 미기재, 변경 후 미수정 등으로
                인하여 개별 통지가 어려운 경우에 한하여 본 항의 공지를 함으로써
                개별 통지를 한 것으로 봅니다.
              </p>
              <p>
                ④ 회사가 제3항에 따라 변경 약관을 공지 또는 통지하면서, 회원에게
                약관 변경 적용일까지 거부의사를 표시하지 않을 경우, 약관의
                변경에 동의한 것으로 간주한다는 내용을 공지 또는 통지하였음에도
                회원이 명시적으로 약관 변경에 대한 거부의사를 표시하지 아니하면,
                회원이 변경된 약관 내용에 동의한 것으로 봅니다.
              </p>
              <p>
                ⑤ 회원이 개정약관의 적용에 동의하지 않는 경우 회사는 개정약관의
                내용을 적용할 수 없으며, 이 경우 회사 또는 회원은 이용계약을
                해지할 수 있습니다.
              </p>
              <h6 className="font-bold txt-black">제4조 (약관 외 준칙)</h6>
              <p>
                ① 회사는 필요한 경우 특정 서비스에 관하여 적용될 사항을 위해
                개별약관이나 운영정책을 정하여 운영할 수 있으며, 해당 내용은
                홈페이지 등을 통해 공지합니다.
              </p>
              <p>
                ② 본 약관에 규정되지 않은 사항에 대해서는 관련 법령 또는
                개별약관, 이용정책, 서비스 이용화면을 통하여 제시된
                개별이용조건(이용요금 등, 이하 “개별계약“이라고 합니다)에서 정한
                바에 따릅니다.
              </p>
              <p>
                ③ 본 약관과 개별약관, 개별계약의 내용이 충돌할 경우 본 약관에
                별도의 규정이 없는 한 개별계약 또는 개별약관에서 정한 바에
                따릅니다.
              </p>
              <p>
                ④ 회원은 서비스 이용시 개별계약 또는 개별약관의 내용을
                확인하여야 하며, 이를 확인하지 않아 발생한 손해에 대해서는
                회사는 고의 또는 중대한 과실이 없는 한 책임을 부담하지 않습니다.
              </p>
              <p>
                ⑤ “회원”이 「장애인고용촉진 및 직업재활법」 소정의 연계고용
                부담금 감면제도를 통하여 장애인 고용부담금 절감 혜택을 받고자
                한다면 “회사”와 별도의 계약을 맺어야 합니다.{" "}
              </p>
              <h6 className="font-bold txt-black">제5조 (회원에 대한 통지)</h6>
              <p>
                ① 회사는 회원 개인에 대한 통지를 하는 경우 본 약관에 별도 규정이
                없는 한 회원이 제공한 휴대전화번호 및 이메일 주소, SMS, 로그인
                시 알림 창 등 적절한 수단으로 통지할 수 있습니다.
              </p>
              <p>
                ② 회사는 회원 전체에 대한 통지의 경우 7일 이상 “고요한 비즈니스
                웹”을 통해 서비스 내에 게시함으로써 제1항의 통지에 갈음할 수
                있습니다. 다만, 회원 본인의 거래와 관련하여 중대한 영향을 미치는
                사항에 대하여는 제1항의 통지를 합니다.
              </p>
              <p>
                ③ 회사는 회원의 연락처 미기재, 변경 후 미수정 등으로 인하여 전
                항 단서에 따른 개별 통지가 어려운 경우에 한하여 전 항의 본문에
                따른 게시를 함으로써 개별 통지를 한 것으로 간주합니다.
              </p>
              <h6 className="font-bold txt-black">
                제6조 (이용계약의 성립 등)
              </h6>
              <p>
                ① “서비스” 이용계약은 “서비스”를 이용하고자 하는 사업자가 본
                약관의 내용에 동의를 한 다음 “회사”가 정한 절차에 따라 “서비스”
                이용을 신청하면, “회사”가 해당 신청에 대하여 승낙함으로써
                체결됩니다.
              </p>
              <p>
                ② “회사”는 전항에 따른 사업자의 이용신청에 대하여 다음 각 호의
                사유가 있는 경우에는 승낙을 하지 않을 수 있고, 가입 이후에도
                다음 각 호의 사유가 확인될 경우에는 이용계약을 직권 해지할 수
                있습니다.
              </p>
              <p>
                1) 본 약관 위반 등의 사유로 이전에 “회원” 자격을 상실하거나
                이용계약의 직권 해지가 있는 경우
              </p>
              <p>
                2) “서비스” 이용정지를 당한 “회원”이 이용정지 기간 중 이용계약을
                임의로 해지하고 “서비스” 이용을 신청한 경우
              </p>
              <p>
                3) 본 약관을 위반하거나 위법 또는 부당한 “서비스” 이용신청이
                확인된 경우
              </p>
              <p>
                4) “서비스” 이용신청시 기재한 사업자 정보에 허위가 있거나 타
                사업자 또는 타인의 정보를 기재한 경우
              </p>
              <p>
                5) “회사”가 이용신청의 거절이 필요하다고 합리적으로 판단한 경우
              </p>
              <p>
                ③ 제1항에 따른 이용 신청에 있어 회사는 전문기관 등을 통한
                실명확인 또는 본인인증 등을 요청할 수 있습니다.
              </p>
              <p>
                ④ 회사는 “서비스” 관련 설비의 여유가 없거나, 기술상 또는 업무상
                문제가 있는 경우에는 이용신청에 대한 승낙을 유보할 수 있습니다.
              </p>
              <p>
                ⑤ 본 조에 따라 회사가 이용신청의 승낙을 하지 아니하거나 유보한
                경우 부득이한 사유가 없을 경우 신청자에게 알리는 것을 원칙으로
                합니다.
              </p>
              <h6 className="font-bold txt-black">제7조 계정 관리</h6>
              <p>
                ① “회원”, “관리책임자” 및 “운영담당자”는 “계정”을 제3자가
                이용하도록 하여서는 안됩니다.
              </p>
              <p>
                ② “회원”, “관리책임자” 및 “운영담당자”는 “계정”이 도용되거나
                제3자가 “서비스”에서 자신의 “계정”을 이용하고 있음을 안 경우
                이를 즉시 “회사”에 통지하고 “회사”의 안내에 따라야 합니다.
              </p>
              <p>
                ③ “회원”, “관리책임자” 및 “운영담당자”가 제2항을 준수하지 않아
                발생한 불이익에 대하여 “회사”는 책임을 지지 않습니다.
              </p>
              <h6 className="font-bold txt-black">제8조 권한</h6>
              <p>
                ① “회원”은 “서비스” 이용을 위하여 “관리책임자” 1인을 반드시
                지정하여야 하고, “관리책임자”로 하여금 “운영담당자”를 지정하게
                할 수 있습니다.
              </p>
              <p>
                ② “회사”는 “관리책임자” 및 “운영담당자”의 권한에 대한 구체적인
                사항을 별도의 운영정책에서 정합니다.
              </p>
              <p>
                ③ “서비스”와 관련한 “관리책임자” 및 “운영담당자”의 일체의 행위는
                권한을 위임한 “회원”의 행위로 인정됩니다.
              </p>
              <h6 className="font-bold txt-black">제9조 서비스의 내용</h6>
              <p>① “서비스”에서 제공하는 주요 내용은 다음과 같습니다.</p>
              <p>1) “회원”의 임직원과 “고요한M” 플랫폼과의 연결</p>
              <p>2) “회원”이 “회사”에게 지급해야하는 “이용요금” 등 비용 관리</p>
              <p>3) “서비스”를 통한 이용내역 관리</p>
              <p>
                ② “회사”는 제1항의 내용 외에 “서비스” 내용을 추가할 수 있으며,
                추가된 “서비스” 내용에 대해서도 본 약관이 동일하게 적용됩니다.
              </p>
              <p>
                ③ “회사”는 기술적 사양의 변경이나 사업 정책적인 판단 하에
                “서비스”의 내용을 변경할 수 있고, 이 경우 변경된 “서비스”의 내용
                및 제공일자를 명시하여 제공일자 7일 전부터 “고요한 비즈니스
                웹”을 통해 공지합니다. 단, “회사”가 합리적으로 예측할 수 없는
                불가피한 여건이나 사정이 있는 경우, 위 공지기간을 단축하거나
                변경 이후에 공지할 수 있습니다.
              </p>
              <p>
                ④ “회원”은 “서비스” 변경에 동의하지 않는 경우 “회사”에 이용계약
                해지 의사를 고지함으로써 “서비스” 이용계약을 해지할 수 있습니다.
              </p>
              <h6 className="font-bold txt-black">
                제10조 서비스의 제공 및 중단
              </h6>
              <p>
                ① “회사”는 “서비스”를 연중무휴, 1일 24시간 제공함을 원칙으로
                합니다.
              </p>
              <p>
                ② “회사”는 “서비스”의 제공에 필요한 경우 정기점검을 실시할 수
                있으며, 정기점검시간은 “고요한 비즈니스 웹”에 공지한 바에
                따릅니다.
              </p>
              <p>
                ③ “회사”는 통신, 전력 등의 공급이 중단되는 불가피한 경우는 물론
                정보통신설비의 보수점검, 증설, 교체, 이전 및 고장 또는 운영상
                상당한 이유가 있는 경우 7일 이전에 공지 후 서비스의 제공을
                일시적으로 중단할 수 있습니다. 다만, “회사”가 사전에 공지할 수
                없는 부득이한 사유가 있는 경우 사후에 공지할 수 있습니다.
              </p>
              <p>
                ④ “회사”는 천재지변, 전쟁, 폭동, 테러, 해킹, DDOS 등 불가항력적
                사유로 서비스가 중단된 경우 즉시 이러한 사실을 공지하되, 만일
                정보통신설비의 작동불능 등의 불가피한 사유로 인해 공지가
                불가능한 경우에는 이러한 사정이 해소된 이후 즉시 공지합니다.
              </p>
              <p>
                ⑤ “회사”는 파산 또는 회생절차 개시 등 정상적인 영업활동이 곤란한
                경우 또는 “회사”의 영업 상 필요한 경우 “서비스”를 종료할 수
                있습니다. 이 경우 회사는 제5조(회원에 대한 통지)에서 정한 방법에
                따라 “서비스”의 종료를 공지 또는 통지할 수 있습니다.
              </p>
              <p>
                ⑥ “회사”는 본 조 제3항 내지 제4항의 사유가 발생한 경우 최대한
                빠른 시간 내에 “서비스”를 재개하도록 최선의 노력을 다합니다.
              </p>
              <p>
                ⑦ “회사”는 사업적 판단에 따라 “서비스”의 일부 또는 전부 중단을
                결정할 수 있고, 이에 따른 “회원”의 “서비스” 이용에 따른
                기대이익에 대한 손실은 “회사”가 보상하지 않습니다.
              </p>
              <h6 className="font-bold txt-black">제11조 서비스의 변경</h6>
              <p>
                “회사”는 상당한 이유가 있는 경우에 운영상, 기술상의 필요에 따라
                제공하고 있는 전부 또는 일부의 “서비스”를 변경할 수 있습니다.
                다만, 변경된 내용이 중대하거나 “회원”에게 불리한 경우에는
                “회사”가 해당 “서비스”를 제공받는 “회원”에게 제5조(회원에 대한
                통지)에 정한 방법으로 통지합니다. 단, “회사”가 합리적으로 예측할
                수 없는 불가피한 여건이나 사정이 있는 경우, 제5조에서 정한 공지
                기간을 단축하거나, 변경 이후에 공지할 수 있습니다.
              </p>
              <p>제 12조 서비스 이용 임직원의 지정 및 결제수단 등록</p>
              <p>
                ① “회원”은 “관리책임자” 및 “운영담당자”를 통해 “고요한 비즈니스
                웹”에서 “서비스” 이용 임직원을 지정할 때, 정확한 임직원 정보가
                등록되도록 하여야 하며, "관리책임자" 및 "운영담당자"를 포함한
                "회원"의 귀책으로 정확하지 않은 임직원 정보가 등록되어 발생한
                문제와 손해에 대해서는 "회원"이 그 책임을 부담합니다. 단,
                “고요한 비즈니스 웹”에서 임직원을 등록, 변경, 삭제하는 방법과
                절차 등은 “회사”가 정한 방법을 따릅니다.
              </p>
              <p>
                ② “회원”은 임직원의 입사 및 퇴사에 따른 “고요한 비즈니스 웹” 내
                임직원 정보를 적시에 등록 및 변경하며, 적시에 등록 및 변경되지
                않아 발생한 문제와 손해에 대해서는 “회원”이 그 책임을
                부담합니다.
              </p>
              <p>
                ③ “회원” 및 “임직원 등”은 “회사”가 정한 방법에 따라 “이용요금”을
                결제할 결제수단을 등록하거나 발급 받아야합니다.
              </p>
              <p>
                ④ “회원”은 “관리책임자” 및 “운영담당자”를 통해 필요한 경우
                “임직원 등”이 “고요한M 앱 등”을 통해 “고요한M”을 호출할 때마다
                입력해야 하는 업무용 호출번호를 설정 및 관리합니다.
              </p>
              <p>
                ⑤ “회원”이 임직원의 “서비스” 이용과 관련한 자체적인 기준을
                마련한 경우 임직원의 해당 기준 준수 여부에 대해 “회사”는 어떠한
                책임도 부담하지 않습니다.
              </p>
              <h6 className="font-bold txt-black">제13조 임직원의 이용방법</h6>
              <p>
                ① “회원”이 제12조에 따라 “고요한 비즈니스 웹”에 등록한 임직원은
                본인 명의의 휴대폰에서 “고요한M” 승객용 앱을 설치하고, “회사”가
                정한 사용 전 등록 및 확인 절차를 완료하여야 합니다.
              </p>
              <p>
                ② 제1항에 따른 절차를 마친 임직원은 “고요한M”을 호출 요청할 수
                있으며, 호출하는 방법은 "고요한M" 승객용 앱을 통해 하거나,
                웹페이지나 콜센터 등을 통해 사전 예약을 하는 등의 방법이
                있습니다.
              </p>
              <p>
                ③ 매 호출시에는 제12조 제3항에 따라 "회원"이 설정한 업무용
                호출번호 입력 또는 기타 "회사"가 제공하는 인증절차를 완료하여야
                합니다.
              </p>
              <p>
                ④ 제1항을 위반한 임직원의 “서비스” 이용과 관련한 문제에 대해서는
                “회사”가 책임을 부담하지 않습니다.
              </p>
              <h6 className="font-bold txt-black">
                제14조 이용요금 및 플랫폼 사용료 결제
              </h6>
              <p>
                ① “임직원 등”이 “서비스”를 이용하여 지불해야하는 “이용요금”은
                “회원”이 선택한 결제 수단에 따라 결제됩니다.
              </p>
              <p>
                ② “회원”과 “임직원 등”이 “서비스” 이용을 위해 등록한 결제수단의
                유효성 또는 한도 등의 문제로 “이용요금”의 결제 실패가 발생하거나
                미입금될 시 해당 금액은 미수처리되며, 미수 금액에 대한 결제가
                정상적으로 완료되기 전까지 “회원” 및 “임직원 등”의 “서비스”
                이용이 제한될 수 있습니다.
              </p>
              <p>
                ③ 등록된 결제수단의 한도 초과, 결제 시스템 장애 등의 사유로 결제
                실패가 발생하거나, 기타의 사유로 “이용요금”의 미수가 발생하는
                경우 “회사”는 “회원”이 등록한 “회원” 명의의 법인 공용카드 혹은
                “임직원 등”이 등록한 “임직원 등” 명의의 결제수단으로 재결제를
                시도할 수 있고, “회원”에게 “임직원 등”의 미수금액을 청구할 수
                있습니다. 이 경우 “회사”는 재결제 시도에 대해서 “회원”과 “임직원
                등”에게 별도로 고지하지 않습니다.
              </p>
              <h6 className="font-bold">제15조 회사의 의무</h6>
              <p>
                ① “회사”는 관련법령과 본 약관을 준수하여 계속적이고 안정적으로
                “서비스”를 제공하기 위하여 최선을 다하여 노력합니다.
              </p>
              <p>
                ② “회사”는 “회원” 및 “회원”의 임직원이 안전하게 “서비스”를
                이용할 수 있도록 개인정보(신용정보 포함) 보호를 위하여
                보안시스템을 갖추어야 하며, 개인정보처리방침을 공시하고
                준수합니다.
              </p>
              <p>
                ③ “회사”는 “서비스”의 이용과 관련하여 “회원”으로부터 제기된
                의견이나 불만이 정당하다고 인정할 경우에는 이를 처리하여야 하며,
                “회원”이 제기한 의견이나 불만사항에 대해서는 “고요한 비즈니스
                웹” 내 게시판 등을 활용하거나 연락처 등을 통하여 “회원”에게
                처리과정 및 결과를 전달합니다.
              </p>
              <h6 className="font-bold txt-black">제16조 회원의 의무</h6>
              <p>
                ① “회원”은 관련법령, 본 약관, 운영정책, 이용안내 및 “회사”가
                공지하거나 통지한 사항 등을 준수하여야 하며, 기타 “회사”의
                업무에 방해되는 행위를 하여서는 안됩니다.
              </p>
              <p>
                ② “회원”은 전항에 따른 준수 사항 중 그 내용의 성격상 “회원”의
                임직원이 준수해야 하는 사항과 구체적인 “서비스” 이용 방법 등을
                임직원에게 안내 및 고지하며, 임직원의 위반행위에 따른 책임을
                부담합니다.
              </p>
              <p>
                ③ “회원”은 “임직원 등”이 “서비스”를 통해 “고요한M”을 호출하기
                전에 출발・도착지 및 예상요금 등 “서비스” 이용에 필요한 사항을
                확인 후 호출할 수 있도록 합니다.
              </p>
              <p>
                ④ “회원”은 “이용요금”에 대한 결제 시 정당하고, 적법한 사용권한을
                가지고 있는 결제수단을 사용하여야 하며, “회사”는 그 여부를
                확인할 수 있고, 해당 결제수단의 적법성 등에 대한 확인이 완료될
                때까지 “서비스” 제공을 중단할 수 있습니다.
              </p>
              <p>
                ⑤ “회원”은 “회사”가 “서비스”를 안전하게 제공할 수 있도록
                “회사”에 협조하여야 하고, “회사”가 “회원”의 본 약관 위반행위를
                발견하여 “회원”에게 해당 위반행위에 대하여 소명을 요청할 경우
                “회원”은 “회사”의 요청에 적극 응하여야 합니다.
              </p>
              <p>
                ⑥ “회원”은 분쟁이 발생한 경우 분쟁의 해결을 위하여 성실히
                임하여야 하고, 분쟁해결에 대한 “회원”의 불성실로 인하여 “회사”에
                손해가 발생한 경우 “회원”은 이에 대한 책임을 부담하여야 합니다.
              </p>
              <p>
                ⑦ “회원”은 “서비스” 이용과 관련하여 임직원의 개인정보를 이용 및
                제공함에 있어서 관련 법령을 준수하여야 합니다.
              </p>
              <h6 className="font-bold txt-black">제17조 회원의 금지행위</h6>
              <p>
                ① “회사”는 “서비스”의 신뢰성을 제고하고 안전한 거래가 이루어질
                수 있도록 “회원” 및 “회원”의 임직원에게 다음 각 호의 행위를
                금지합니다.
              </p>
              <p>
                1) “회사”가 제공하는 이용방법에 의하지 아니하고 비정상적인
                방법으로 “서비스”를 이용하거나 시스템에 접근하는 행위
              </p>
              <p>
                2) 리버스엔지니어링, 디컴파일, 디스어셈블 및 기타 일체의
                가공행위를 통하여 “서비스”를 복제, 분해 또는 모방 기타 변형하는
                행위
              </p>
              <p>3) 탑승의사 없이 호출을 하는 행위</p>
              <p>
                4) “회사”의 영업활동을 고의로 방해하거나 안정적 운영을 방해할 수
                있는 행위
              </p>
              <p>
                5) “회사”가 제공하는 이벤트 혜택 등의 경제상의 이익을 부당하게
                수취하는 행위
              </p>
              <p>
                6) “회사”의 사전 동의 없이 제3자에게 “계정” 및 본 약관에 따른
                권리 또는 의무의 전부 또는 일부를 양도·임대하거나 담보로
                제공하는 행위
              </p>
              <p>
                7) “회사” 및 기타 제3자의 저작권 등 지적재산권에 대한 침해행위
              </p>
              <p>8) 기타 불법적이거나 부당한 행위</p>
              <p>
                ② “회사”는 “회원”이 본 조의 금지행위를 하는 경우 “서비스” 이용을
                제한할 수 있으며, 이 경우 발생하는 모든 책임은 “회원”이
                부담합니다.
              </p>
              <h6 className="font-bold txt-black">제18조 이용제한 등</h6>
              <p>
                ① “회사”는 “회원”이 관련 법령, 본 약관 , 운영정책, 이용안내 및
                “회사”가 공지하거나 통지한 사항 등을 위반하는 경우 “서비스”의
                이용제한 및 이용정지(이하 “이용제한”이라고 합니다)를 할 수
                있습니다. “이용제한”의 구체적인 기준 등에 대해서는 별도의
                운영정책 등에서 정합니다.
              </p>
              <p>
                ② 제1항의 “이용제한”은 제5조(회원에 대한 통지)에 따라 “회원”에게
                그 의사를 표시한 때에 효력이 발생합니다.
              </p>
              <p>
                ③ “회사”는 “회원”이 해당 사유를 소명하는 등 “회사”가 정하는
                기준을 충족하는 경우 “이용제한” 조치를 해소할 수 있습니다.
              </p>
              <h6 className="font-bold txt-black">
                제19조 이용계약 해제, 해지 등
              </h6>
              <p>
                ① “회원”은 언제든지 “서비스” 이용계약의 해지를 신청할 수 있으며,
                “회사”는 관련 법령에서 정하는 바에 따라 이를 즉시 처리하여야
                합니다. 다만, “회원”에게 미수가 있을 경우에는 미수에 대한 결제를
                완료한 이후에 해지신청이 가능합니다.
              </p>
              <p>
                ② “회원”이 이용계약을 해지할 경우 “회사”는 관련 법령 및
                개인정보처리방침에 따라 정보를 보유해야 하는 경우를 제외하고는
                즉시 “회원” 및 그 임직원의 정보를 삭제합니다.
              </p>
              <p>
                ③ “회사”는 “회원”에게 다음 각 호에 해당하는 사유가 발생하거나
                확인된 경우 이용계약을 해지할 수 있습니다.
              </p>
              <p>
                1) “회원”이 “서비스”의 원활한 진행을 방해하는 행위를 하거나
                시도한 경우
              </p>
              <p>2) “회원”이 고의로 회사의 영업을 방해한 경우</p>
              <p>3) “회원”이 고의로 미수를 발생시킨 것으로 판단되는 경우</p>
              <p>
                4) “회원”에게 제6조에서 정한 이용계약의 승낙거부사유가 있음이
                확인된 경우
              </p>
              <p>5) “회원”이 본 약관에 위배되는 행위를 한 경우</p>
              <p>
                ④ “회사”가 이용계약을 해지하는 경우 “회사”는 “회원”에게
                해지사유를 밝혀 해지의사를 통지합니다. 이 경우 “회사”는 해지를
                하기 전에 상당한 기간을 정하여 “회원”에게 이의 신청의 기회를
                부여합니다. 다만, 본 약관 및 운영정책에서 정하는 사유가 있을
                경우에는 별도의 이의 신청 기간을 부여하지 않을 수 있습니다.
              </p>
              <h6 className="font-bold txt-black">제20조 책임제한</h6>
              <p>
                ① “회원”, “관리책임자” 및 “운영담당자”가 사업자정보 및
                “계정”(아이디, 이메일, 로그인 비밀번호 등) 등을 타인에게
                제공하거나, “회원”의 임직원 관리소홀로 유출됨으로써 발생하는
                피해에 대해서 “회사”는 고의 또는 중대한 과실이 없는 한 책임을
                부담하지 않습니다.
              </p>{" "}
              <p>
                ② “회사”는 “회원”, “관리책임자” 및 “운영담당자”, “회원”의
                임직원의 귀책사유로 인한 “서비스” 이용의 장애에 대하여는 고의
                또는 중대한 과실이 없는 한 책임을 지지 않습니다.
              </p>{" "}
              <p>
                ③ “회사”는 “회원”, “관리책임자” 및 “운영담당자”가 “서비스”와
                관련하여 게재한 정보, 자료, 사실의 신뢰도, 정확성 등의 내용에
                관하여는 고의 또는 중대한 과실이 없는 한 책임을 부담하지
                않습니다
              </p>{" "}
              <p>
                ④ “회사”는 관계법령의 변경, 천재지변, 디도스(DDOS)공격, IDC
                장애, 기간통신사업자의 회선 장애 또는 이에 준하는 불가항력으로
                인하여 “서비스”를 제공할 수 없는 경우에는 “서비스” 제공에 관한
                책임이 면제됩니다.
              </p>{" "}
              <p>
                ⑤ “회사”는 “회원”의 “서비스” 이용과 직접적으로 관련이 없는
                분쟁에 관여하지 않으며, “회원”(또는 “회원”의 임직원)과 “회원”과
                제 3 자 간의 분쟁을 포함하여 도난, 폭행, 성범죄 등에 대해서는
                “회사”의 고의 또는 중대한 과실이 없는 한 책임을 부담하지
                않습니다.
              </p>{" "}
              <p>
                ⑥ “회원”이 “장애인 연계고용제도”를 활용한 “장애인 고용부담금”
                절감 혜택을 받기 위한 별도 계약을 맺지 않아 생기는 기대 이익의
                손실 등에 대해서는 “회사”가 책임지지 않습니다.
              </p>{" "}
              <h6 className="font-bold txt-black">
                제21조 (준거법 및 재판관할)
              </h6>
              <p>
                ① 본 약관과 관련된 사항에 대하여는 대한민국법을 준거법으로
                합니다.
              </p>
              <p>
                ② 회사와 회원 간에 발생한 분쟁에 관한 소송은 관할법원에
                제소합니다.
              </p>
              <p>부칙</p>
              <p>본 약관은 2021년 01월 01일부터 적용됩니다.</p>
            </div>
            <div className="item-body">
              <input
                className="form-check-input"
                id="agreecheck1"
                type="checkbox"
                checked={isAgree1}
                onChange={(event) => setIsAgree1(event.target.checked)}
              />
              <label
                className="form-check-label txt-dark-gray font-bold"
                htmlFor="agreecheck1"
              >
                고요한 비즈니스 이용약관<span className="txt-red">(필수)</span>
              </label>
            </div>
            <div className="item-header">
              <p>
                코액터스㈜가 운영하는 고요한모빌리티(이하 고요한M)는 B2B 플랫폼
                ‘고요한 비즈니스’에서 아래의 목적으로 개인정보를 수집 및
                이용하며, 이용자의 개인정보를 안전하게 취급하는데 최선을
                다하겠습니다.
                <br />
              </p>
              {`< 필수 수집 항목 >`}
              <table className="table font-small">
                <thead>
                  <tr>
                    <td>목적</td>
                    <td>항목</td>
                    <td>보유기간</td>
                  </tr>
                  <tr>
                    <td>이용자 식별 및 관리</td>
                    <td>이메일, 패스워드, 이름, 부서명, 휴대전화번호</td>
                    <td rowSpan="3">서비스 탈퇴 후 즉시 삭제</td>
                  </tr>
                  <tr>
                    <td>공지사항 및 안내</td>
                    <td>이메일, 이름</td>
                  </tr>
                  <tr>
                    <td>로그인 서비스 제공</td>
                    <td>이메일</td>
                  </tr>
                </thead>
              </table>
              <p>
                더 자세한 내용에 대해서는 고요한M 개인정보처리방침(
                <a
                  href="https://www.goyohanmobility.com/agreement/privacy-policy"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span className="txt-blue">
                    www.goyohanmobility.com/agreement/privacy-policy
                  </span>
                </a>
                )을 참고하시기 바랍니다.
              </p>
            </div>
            <div className="item-body">
              <input
                className="form-check-input"
                id="agreecheck2"
                type="checkbox"
                checked={isAgree2}
                onChange={(event) => setIsAgree2(event.target.checked)}
              />
              <label
                className="form-check-label font-bold txt-dark-gray "
                htmlFor="agreecheck2"
              >
                개인정보 수집 및 이용 동의
                <span className="txt-red">(필수)</span>
              </label>
            </div>
            <div className="item-header">
              <p>
                코액터스㈜가 운영하는 고요한모빌리티(이하 고요한M)는 B2B 플랫폼
                ‘고요한 비즈니스’에서 이벤트 안내 또는 사례 리포트의 목적으로
                아래의 개인정보를 수집 및 이용하며, 동의하지 않아도 서비스
                이용이 가능합니다.
              </p>
              {`
							< 선택 수집 항목 >
						`}
              <table className="table font-small">
                <thead>
                  <tr>
                    <td>목적</td>
                    <td>항목</td>
                    <td>보유기간</td>
                  </tr>
                  <tr>
                    <td>이벤트 안내, 사례 리포트</td>
                    <td>이메일, 패스워드, 이름, 부서명, 휴대전화번호</td>
                    <td>서비스 탈퇴 후 즉시 삭제</td>
                  </tr>
                </thead>
              </table>
            </div>
            <div className="item-body">
              <input
                className="form-check-input"
                id="agreecheck3"
                type="checkbox"
                checked={isAgree3}
                onChange={(event) => setIsAgree3(event.target.checked)}
              />
              <label
                className="form-check-label font-bold txt-dark-gray "
                htmlFor="agreecheck3"
              >
                개인정보 수집 및 이용 동의(선택)
              </label>
            </div>
            <div className="item-header">
              <p>
                코액터스㈜가 운영하는 고요한모빌리티(이하 고요한M)는 B2B 플랫폼
                ‘고요한 비즈니스’에서 아래의 사항에 대한 이메일 또는 휴대전화
                알림을 제공합니다.
              </p>
              <p>1. 이벤트 및 프로모션 안내</p>
              <p>2. 사례 리포트</p>
              <p>3. 이외 이용자의 편의를 위한 알림</p>
            </div>
          </div>
          <div className="item-body">
            <input
              className="form-check-input"
              id="agreecheck4"
              type="checkbox"
              checked={isAgree4}
              onChange={(event) => setIsAgree4(event.target.checked)}
            />
            <label
              className="form-check-label font-bold txt-dark-gray "
              htmlFor="agreecheck4"
            >
              마케팅 수신 동의(선택)
            </label>
          </div>
          <section className="display-flex flex-column align-items-center">
            <span className="txt-gray font-bold pb-1">
              약관을 동의하는 것으로 계약서를 갈음합니다.
            </span>
            <div>
              <input
                className="form-check-input"
                id="agreeAll"
                type="checkbox"
                checked={isAllAgree}
                onChange={allAgreeCheck}
              />
              <label
                className="form-check-label font-bold txt-dark-gray"
                htmlFor="agreeAll"
              >
                모두 동의합니다
              </label>
            </div>
          </section>
          <div className="button-area mt-4 mb-4 txt-center">
            <button
              className="btn-white-md mr-4"
              type="button"
              onClick={() => history.goBack()}
            >
              이전
            </button>
            <button className="btn-blue-md" ref={submitButtonRef} type="submit">
              다음
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default Agreement;
